import { CustomButtonProps } from '@/components/Button/Button';

export const buttonRunnerPropositionButtonProps: CustomButtonProps = {
  fontSize: 'sm',
  fontWeight: 'bold',
};
